import {useDebounce} from '@logistics-frontend/hooks'
import {useFormContext} from '@yandex-delivery/form'
import {useMemo} from 'react'

import {i18n} from 'src/shared/config'
import {type PickupStation, DestinationPointDeliveryMethod, SourcePointDeliveryMethod} from 'src/shared/types'

import {useParcelPhysicalDimensions} from '../../DeliveryIntervalsNdd/use-parcel-physical-dimensions'
import {useFetchOffersInfo} from './use-fetch-offers-info'
import {formatSchedule} from './utils'

export const useDetails = (point?: PickupStation) => {
  const time = useMemo(() => {
    switch (point?.type) {
      case 'terminal':
        return i18n('ndd.pickup_points.terminal.storage_time', '3 дня')
      case 'pickup_point':
        return i18n('ndd.pickup_points.pickup_point.storage_time', '7 дней')
      case 'post_office':
        return i18n('ndd.pickup_points.post_office.storage_time', '7 дней')
      case 'sorting_center':
        return i18n('ndd.pickup_points.sorting_center.storage_time', '7 дней')
      default:
        return ''
    }
  }, [point?.type])

  const schedule = useMemo(() => {
    if (point?.schedule === undefined) {
      return []
    }

    return formatSchedule(point?.schedule, i18n)
  }, [point?.schedule])

  return {
    time,
    schedule,
  }
}

export const useSelectedPointInformation = (
  pointType?: SourcePointDeliveryMethod.DropOffPoint | DestinationPointDeliveryMethod.PickUpPoint,
) => {
  const {watch} = useFormContext()
  const sourcePointDeliveryMethod = watch('sourcePoint._deliveryMethod')
  const sourcePointStationId = watch('sourcePoint.station.station_id')
  const sourcePointDropOffPointId = watch('sourcePoint.dropOffPoint.point.id')
  const destinationPointPickupPointId = watch('destinationPoints.0.pickUpPoint.point.id')

  const {fetchOffersInfoHandler, isOffersInfoPending, offersInfo} = useFetchOffersInfo()
  const {places} = useParcelPhysicalDimensions()

  useDebounce(
    () => {
      fetchOffersInfoHandler({
        sourcePointStationId,
        sourcePointDropOffPointId,
        pointType,
        sourcePointDeliveryMethod,
        places,
      })
    },
    100,
    [destinationPointPickupPointId],
  )

  return {
    isPending: isOffersInfoPending,
    payload: offersInfo,
  }
}
